module.exports = __webpack_public_path__ + "static/assets/fcb21f71cf289f827e01b18b7c3fdc85.mp3";